import FeatureToggleApi from "../../services/api/FeatureToggle";
import {
  getPath,
  getServiceIdsFromConditions,
  isServiceIdConditionPresent,
  pushOrUpdate,
} from "../../utils";
import ActionTypes from "./ActionTypes";
import { setStatus, setLoader } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import * as Comparators from "../../constants/FeatureToggle/Comparators";
import _ from "lodash";

function handleError(err) {
  console.log("error in feature actions:", err);
}

const payload = {
  clientId: "1",
};

export const setFeatureToggleList = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_TOGGLE_LIST,
    payload,
  };
};

export const setActiveFeatureToggle = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FEATURE_TOGGLE,
    payload,
  };
};

export const setActiveFiltersToggle = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_TOGGLE,
    payload,
  };
};

export const setCurrentPageFeatureToggle = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_FEATURE_TOGGLE,
    payload,
  };
};

export const resetStateFeatureToggle = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_FEATURE_TOGGLE,
    payload,
  };
};

export const setDSMEnabledFeatures = (payload) => {
  return {
    type: ActionTypes.SET_DSM_ENABLED_FEATURES,
    payload,
  };
};

export const getFeatureToggleList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let featureTogglePayload = {
        ...payload,
        filters: { ..._.cloneDeep(filters), ...payload },
        pageRequest: pageRequest,
      };
      _.unset(featureTogglePayload, ["filters", "serviceId"]);
      dispatch(setLoader(true));
      let response = await FeatureToggleApi.getFeatureToggleList(
        featureTogglePayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setFeatureToggleList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageFeatureToggle(getPath(pageRequest, "page", 1))
          );
        }
        dispatch(setDSMEnabledFeatures(response.deliveryServiceFeatures));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFiltersToggle(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetStateFeatureToggle({ state: "activeFiltersToggle" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getFeatureToggle = (id) => async (dispatch) => {
  try {
    let featureTogglePayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await FeatureToggleApi.getFeatureToggle(
      featureTogglePayload
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveFeatureToggle(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createFeatureToggle = (url, data) => async (dispatch) => {
  try {
    let featureTogglePayload = { ...data, ...payload };
    dispatch(setLoader(true));
    let response = await FeatureToggleApi.createFeatureToggle(
      url,
      featureTogglePayload
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const checkFeatureToggleEnabled = (url, data) => async (dispatch) => {
  try {
    let featureTogglePayload = { ...data, ...payload };
    dispatch(setLoader(true));
    let response = await FeatureToggleApi.getFeatureToggleEnabled(
      url,
      featureTogglePayload
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getBulkDeleteUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await FeatureToggleApi.getBulkDeleteUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
